import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/2.0/';

export const getCurrentUserURL = () => '/current-user/info';
export const loginURL = () => '/login';
export const logoutURL = () => '/logout';
export const getSubscriptionTrialvsPaidURL = () => '/admin/stats/subscriptions-trial-vs-paid';
export const getFlagsPerDayURL = () => '/admin/stats/view/materialized_flags_per_day_view';
export const getSongsPerDayURL = () => '/admin/stats/view/materialized_songs_per_day_view';
export const getAnalyticsEventsPerDayURL = () => '/admin/stats/view/materialized_analytics_events_per_day_view';
export const getUsersPerDayURL = () => '/admin/stats/view/materialized_users_per_day_view';
export const getUsersPerMonthURL = () => '/admin/stats/view/materialized_users_per_month_view';
export const getSubscribersPerDayURL = () => '/admin/stats/subscribers-per-day';
export const getTopYoutubeImportsURL = () => '/admin/stats/top-youtube-imports';
export const getFailedYoutubeImportsURL = () => '/admin/stats/failed-youtube-imports';
export const getSegmentEventsStudioURL = () => '/admin/stats/view/materialized_analytics_events_per_segment_studio';
export const getSegmentEventsSongwriterURL = () => '/admin/stats/view/materialized_analytics_events_per_segment_songwriter';
export const getUserSegmentsByWeekURL = () => '/admin/stats/view/materialized_user_segments_per_registration_week';
export const getFirstProgramStartsPerWeekURL = () => '/admin/stats/view/materialized_first_program_starts_per_week';

export const http = axios.create({
  withCredentials: true,
  baseURL: API_BASE_URL,
});
